import React, { useState } from "react";
import ReactDatatable from "@mkikets/react-datatable";
import { useGetCryptocurrencyQuery } from "../../../redux/cryptocurrencyApi";
import { useGetNetworkQuery } from "../../../redux/networkApi";
import { Button } from "react-bootstrap";
import AddCryptocurrency from "../../partial/AddCryptocurrency";
import EditCryptocurrency from "../../partial/EditCryptocurrency";
import ViewCryptocurrency from "../../partial/ViewCryptocurrency";

import { useTranslation } from "react-i18next";

function Cryptocurrencies() {
    const { t } = useTranslation();
    const { data: apiResponse } = useGetCryptocurrencyQuery();
    const { data: networkResponse } = useGetNetworkQuery();

    const users = apiResponse?.data || [];
    const networks = networkResponse?.data || [];

    // Edit Modal State
    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState({});

    const handleEdit = (cryptocurrency) => {
        setEditData(cryptocurrency);
        setShowEdit(true);
    };

    // View Modal State
    const [showView, setShowView] = useState(false);
    const [viewData, setViewData] = useState({});

    const handleView = (cryptocurrency) => {
        setViewData(cryptocurrency);
        setShowView(true);
    };

    // Add Modal State
    const [showAdd, setShowAdd] = useState(false);


    const columns = [
        {
            key: "srno.",
            text: t('sr_no'),
            className: "sr_no.",
            align: "left",
            sortable: true,
            cell: (row, index) => index + 1,
        },
        {
            key: "coin_name",
            text: t('name'),
            className: "name",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <><img style={{ width: "20px", height: "20px" }} className="img-fluid" src={record.logo_url} alt="" />{"  "}{record.coin_name}</>;
            },
        },
        {
            key: "coin_symbol",
            text: t('symbol'),
            className: "name",
            align: "left",
            sortable: true,
        },
        {
            key: "symbol",
            text: t('select_network'),
            className: "name",
            align: "left",
            sortable: true,
        },
        {
            key: "usd_price",
            text: t('usd_price'),
            className: "usd_price",
            align: "left",
            sortable: true,
        },
        {
            key: "is_token",
            text: t('is_token'),
            className: "is_token",
            align: "left",
            sortable: true,
        },
        {
            key: "wallet_type",
            text: t('wallet_type'),
            className: "wallet_type",
            align: "left",
            sortable: true,
        },
        {
            key: "transfer_fee_status",
            text: t('transfer_fee_status'),
            className: "transfer_fee_status",
            align: "left",
            sortable: true,
        },
        {
            key: "is_swapable",
            text: t('is_swapable'),
            className: "is_swapable",
            align: "left",
            sortable: true,
        },
        {
            key: "action",
            text: t('actions'),
            className: "Action d-flex",
            align: "left",
            sortable: true,
            cell: (record) => {
                return (
                    <>
                        <Button variant="primary" size="sm" className="me-1" onClick={() => handleView(record)}>
                            {t('view')}
                        </Button>
                        <Button variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                            {t('edit')}
                        </Button>
                        {/* {record.is_token === "yes" && (
                            <Button variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                                {t('edit')}
                            </Button>
                        )} */}
                        {/* {record.is_token === "no" && (
                            <Button disabled variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                                {t('no_edit')}
                            </Button>
                        )} */}
                    </>
                );
            },
        },
    ];

    const config = {
        page_size: 5,
        length_menu: [5, 10, 20, 50],
        filename: "Fund Request List",
        no_data_text: t('no_record_found'),
        button: {
            // print: true,
            // csv: true,
        },
        language: {
            filter: t('search_in_records'),

            pagination: {
                first: t('first'),
                previous: t('previous'),
                next: t('next'),
                last: t('last'),
            },
        },
        show_length_menu: true,
        show_filter: false,
        show_pagination: true,
        show_info: true,
    };

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex align-items-center justify-content-between mb-4">
                <h1>{t('cryptocurrencies')}</h1>
                <Button variant="primary" onClick={() => setShowAdd(true)}>
                    {t('add_new_cryptocurrency')}
                </Button>
            </div>

            <div className="card">
                <div className="card-body pt-4">
                    <ReactDatatable
                        key={`datatable-aa`}
                        config={config}
                        records={users}
                        columns={columns}
                        dynamic={false}

                    />

                </div>
            </div>

            <EditCryptocurrency
                show={showEdit}
                onHide={() => setShowEdit(false)}
                cryptocurrency={editData}
                users={users}
            />

            <ViewCryptocurrency
                show={showView}
                onHide={() => setShowView(false)}
                viewData={viewData}
            />

            <AddCryptocurrency
                show={showAdd}
                onHide={() => setShowAdd(false)}
                networks={networks}
                users={users}
            />

        </section>
    );
}

export default Cryptocurrencies;
